import cssIcon from "../img/Icons/Logos/CssLogo.png";

export default function CSSSkill() {
    return (
        <div className="skillTile">
            <img src={cssIcon} alt="csharp"/>
            <div className="skillTexts">
                <h2>CSS</h2>
            </div>
        </div>
    )
}